export type BetaProgramAction = 'add' | 'remove'; // whether to add or remove device from beta program

export type BetaProgramRegistrationPayload = {
  nukiId: string;
  email: string;
  firstName: string;
  lastName: string;
  action: BetaProgramAction;
  language?: string;
};

export const BETA_PROGRAM_REGISTRATION_ERROR = {
  INVALID_NUKI_ID: 'INVALID_NUKI_ID',
  VALIDATION: 'VALIDATION',
  UNKNOWN: 'UNKNOWN',
} as const;

export type BetaProgramRegistrationError =
  (typeof BETA_PROGRAM_REGISTRATION_ERROR)[keyof typeof BETA_PROGRAM_REGISTRATION_ERROR];

export type BetaProgramRegistrationResult =
  | { success: true }
  | { success: false; error: BetaProgramRegistrationError };
